import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import InputTag from "../InputTag/InputTag";
import { Button } from "react-bootstrap";
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FormattedMessage, injectIntl } from 'react-intl';
import CreateFilterPopup from "../Dashboard/filter/CreateFilterPopup";
import { filterData } from "../Dashboard/filter/filterDummyJson";
import CreateFilterHOC from "../Dashboard/hoc/CreateFilterHOC";
import { useStore } from "../../../contexts/StoreProvider";
import { IFilterTest, ITestInfo } from "../../../models/ITestInfo";
import { formatMessage } from "../../../translations/format-message";
import { Link, useNavigate } from "react-router-dom";
import RoutesConstants from "../../../shared-components/Routes/routes.constants";
import DeletePopup from "../../agent-dashboard/components/Delete/DeletePopup";
import DeletePopupHOC from "../../agent-dashboard/hoc/DeletePopupHOC";
import TestCompare from "../../test-compare/TestCompare";
import Pagination from "../../../shared-components/Grid/Pagination";
import { pageLimitOptions } from "../../../constants/options.constant";
import { Box, CircularProgress } from "@mui/material";
import CustomPagination from "../../../shared-components/Pagination/CustomPagination";
import FilterTest from "./filter/filter-test";
import { ITestFilter } from "../../../core/stores/admin-store";
import { toJS } from "mobx";

const Test = (props: any) => {
    const navigate = useNavigate();
    const { adminStore, testStore } = useStore();

    const { resetTestInterpretation } = testStore;
    const { getAllTest, getAllTestState, resetGetAllTestState, allTest, allTrainerList, getTrainerListState, 
        getTrainerList, deleteTestState, deleteTest, resetDeleteTest, testFilterState, testFilterStateValue,
        updateTestSearchingText, resetTestFilter, testPaginationState,updateTestPageNumber,updateTestPageSize,
        resetTestPagingState } = adminStore;
    const [deleteTestId, setDeleteTestId] = useState<number>(-1);
    const [deleteTestName, setDeleteTestName] = useState<string>("");
    const [selectedTestsForComparison, setSelectedTestsForComparison] = useState<number[]>([])
    const [isSearchPerformed, setIsSearchPerformed] = useState<boolean>(false);

    const handleCreateFilterModalClose = () => {
        props.createFilterPopupToggleHandler();
    }

    const handleCreateFilterModalOpen = () => {
        props.createFilterPopupToggleHandler();
    }

    const callGetAllTest = () => {
        getAllTest(testPaginationState.PagingDetails.PageNo,testPaginationState.PagingDetails.PageSize,testFilterState.TestType, testFilterState.Roles, testFilterState.SearchText, testFilterState.trainerList);

    }
    const performSearch = (searchText: string) => {
        updateTestSearchingText(searchText);
        updateTestPageNumber(1,true);
    };
    /*
      initial load
    */
    useEffect(() => {
        //callGetAllTest();
        //resetTestInterpretation();
    }, []);

    useEffect(() => {
        getTrainerList()
        updateTestSearchingText("");
    }, []);

    useEffect(() => {
        if(testPaginationState.PagingDetails.isPagerChange){
            callGetAllTest();
            resetGetAllTestState();
            resetTestPagingState();
        }
    }, [testPaginationState.PagingDetails.isPagerChange]);

    // useEffect(() => {

    //     // if (getTrainerListState.success) {
    //     //     testFilterStateValue.testFilterList.map((old: any) => {
    //     //         if (old.heading == 'Trainer') {
    //     //             let settingValue = allTrainerList.map((item) => {
    //     //                 testFilterState.trainerList = testFilterState.trainerList ? testFilterState.trainerList + "," + item.TrainerId : item.TrainerId;
    //     //                 return { ...item, Id: item.TrainerId, checked: false, name: item.TrainerName, email: item.TrainerEmailId }
    //     //             })
    //     //             old.value = settingValue;
    //     //             return old
    //     //         }
    //     //         return old
    //     //     })
    //     // }
    // }, [getTrainerListState.success]);


    useEffect(() => {
        if (deleteTestState.success) {
            callGetAllTest();
            resetDeleteTest();
            props.deletePopupToggleHandler();
        }
    }, [deleteTestState.success]);

    useEffect(() => {
        if (testFilterState.SearchText.replace(/\s+/g,' ').trim()  === '' && isSearchPerformed) {
            setIsSearchPerformed(() => false);
            updateTestSearchingText('');
            callGetAllTest();
        }
    }, [testFilterState.SearchText]);

    const [disablePagination, setDisablePagination] = useState<boolean>(false);
    
    const onPageChanged = (pageNumber: number) => {
        updateTestPageNumber(pageNumber);
    };

    const onPageLimitChanged = (evt: any) => {
        updateTestPageSize(parseInt(evt.target.value));
    };

    const handleViewResult = (testId: number, userEmail: string) => {
        navigate(`${RoutesConstants.TestResult}/${testId}`);
    }

    const handleDeleteTest = (testId: number) => {
        deleteTest(testId);
    }


    const handleDeleteClick = (testId: number, testName: string) => {
        setDeleteTestId(testId);
        setDeleteTestName(testName);
        props.deletePopupToggleHandler();
    };

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter' && testFilterState.SearchText.replace(/\s+/g,' ').trim() !== '') {
            updateTestPageNumber(1, true);
            //callGetAllTest();
            setIsSearchPerformed(() => true);
        }
    }
    const handleClear = () => {
        resetTestFilter();
        callGetAllTest();
        updateTestSearchingText("");
    }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
    const handleCancel = (heading: any, key: IFilterTest) => {
        var rolefilter = testFilterState.Roles;
        var testTypefilter = testFilterState.TestType;
        var trainerListfilter = testFilterState.trainerList;
        //console.log(testFilterState);
        if (rolefilter.length > 0) {
            if (rolefilter.length == 1) {
                testFilterState.Roles = "";
                testFilterStateValue.testFilterList[1].value.map((x: IFilterTest) => { x.checked = false });
            }
            else {
                let rolesArray = rolefilter.split(',');
                rolesArray = rolesArray.filter(role => role !== key.name);
                testFilterState.Roles = rolesArray.join(',');
                testFilterStateValue.testFilterList[1].value.map(x => { if (x == key) x.checked = false}); 
            }
        }

        if (testTypefilter.length > 0) {
            if (testTypefilter.length == 1) {
                testFilterState.TestType = "";
                testFilterStateValue.testFilterList[2].value.map(x => { if (x == key) x.checked = false}); 
            }
            else {
                let testType = testTypefilter.split(',');
                testType = testType.filter(test => test !== key.name.toString());
                testFilterState.TestType = testType.join(',');
                testFilterStateValue.testFilterList[2].value.map(x => { if (x == key) x.checked = false}); 
            }
        }

        if (trainerListfilter.length > 0) {
            if (trainerListfilter.length == 1) {
                testFilterState.trainerList = "";
                testFilterStateValue.testFilterList[0].value.map(x => { if (x == key) x.checked = false}); 
            }
            else {
                let trainerList = trainerListfilter.split(',');
                trainerList = trainerList.filter(x => x !== key.id?.toString());
                testFilterState.trainerList = trainerList.join(',');
                testFilterStateValue.testFilterList[0].value.map(x => { if (x == key) x.checked = false}); 
            }
        }
        updateTestPageNumber(1,true);
    }

    const handleRemoveFromCompariosn = (testIdToBeRemoved: any) => {
        const remainingTests = selectedTestsForComparison.filter((testId: any) => testId != testIdToBeRemoved)
        if (remainingTests) {
            setSelectedTestsForComparison(remainingTests);
        }
    }

    const handleAddToComparison = (id: number) => {
        const testToBeAdded = allTest.find((old: ITestInfo) => old.TestId === id);
        if (testToBeAdded && selectedTestsForComparison) {
            setSelectedTestsForComparison([...selectedTestsForComparison, testToBeAdded.TestId]);
        }
    }

    const handleRemoveAllTests = () => {
        setSelectedTestsForComparison([])
    }

    const getCheckedItems = (testFilter: ITestFilter[], categoryHeading: string) => {
        const filterType = toJS(testFilter).find((filter: ITestFilter) => filter.heading === categoryHeading);
        return filterType ? filterType.value.filter((item: IFilterTest) => item.checked).map((item: IFilterTest) => item.name) : [];
    };

    const getCheckedTrainerIds = (testFilter: ITestFilter[], categoryHeading: string) => {
        // console.log(categoryHeading);
        const filterType = toJS(testFilter).find((filter: ITestFilter) => filter.heading === categoryHeading);
        return filterType ? filterType.value.filter((item: IFilterTest) => item.checked).map((item: IFilterTest) => item.id) : [];
    };

    const handleApplyFilter = (testFilter: ITestFilter[]) => {
        const checkedTestTypes = getCheckedItems(testFilter, "Test Types").join(',');
        const checkedRoles = getCheckedItems(testFilter, "Roles").join(',');
        const checkedTrainers = getCheckedTrainerIds(testFilter, "Trainer").join(',');
        testFilterState.Roles = checkedRoles;
        testFilterState.TestType = checkedTestTypes;
        testFilterState.trainerList = checkedTrainers;
        testFilterStateValue.testFilterList = [...testFilter];
        //updateTestSearchingText("");
        updateTestPageNumber(1,true);
        handleCreateFilterModalClose();
    }

    return (
        <>
            {props.showCreateFilterPopup && (
                <FilterTest modalClosed={handleCreateFilterModalClose} applyFilter={handleApplyFilter} />
            )}
            {props.showDeletePopup && (
                <DeletePopup modalClosed={props.deletePopupToggleHandler} isLoading={deleteTestState.inProgress} Id={deleteTestId} Title={deleteTestName} deleteHandler={handleDeleteTest} />
            )}
           <div className="dashboardTopbar">
                <div className="container">
                   <div className="row align-items-center">
                       <div className="col-8">
                           <InputTag size="search" icon={true} inputType="text" inputvalue={testFilterState.SearchText} inputValue={updateTestSearchingText} onKeyDown={handleKeyDown} placeholderText={formatMessage("search")} clickedFn={performSearch} FaIcon={faSearch} />
                        </div>
                        <div className="col-4 d-flex justify-content-md-end justify-content-center align-items-center">
                            {
                                !(getAllTestState.inProgress || (!getAllTestState.success && getAllTestState.error === '' )) && 
                                    <p className="text-dark me-2"><FormattedMessage id="TestTakenCount" />:&nbsp;{testPaginationState.PagingDetails.TotalRecords}</p>
                            }
                           <button className="btn btn-primary" data-toggle="tooltip" data-placement="bottom" title="Tooltip on bottom" onClick={handleCreateFilterModalOpen}>
                              <i className="fa fa-filter"></i> <FormattedMessage id="test_filter_titile" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                {
                    testFilterStateValue.testFilterList.some(obj => obj.value.some(item => item.checked === true))
                     &&
                    <>
                        <div className="row align-items-start">
                        <div className="col-2">
                                <button className="btn-link text-danger" onClick={() => handleClear()}>
                                    <i className="fa fa-redo small me-1"></i> <FormattedMessage id="Reset Filters" />
                                </button>
                            </div>
                            <div className="col-10">
                                {testFilterStateValue.testFilterList.map((item) => {
                                    return (
                                        <>
                                        {item.value.filter(data => data.checked).length > 0 && (
                                            <div className="d-flex align-items-start mb-2">
                                                <h4 className="text-muted mb-0 mt-2">
                                                    {item.value.filter(data => data.checked).length > 0 && item.heading}
                                                </h4>
                                                <div className="overflow-scroll white-space-nowrap">
                                                    {
                                                        item.value.map((key) => {
                                                            return <>{
                                                                key.checked &&
                                                                <Button className="d-inline-flex align-items-center filter-wrap ms-2"  variant="outline-secondary"
                                                                    data-toggle="tooltip"
                                                                    data-placement="bottom"
                                                                    title={formatMessage('delete')}
                                                                    size="sm">{key.name}
                                                                    {/* {
                                                                        (key.email != '') && (item.heading == 'Trainer') && (<span>({key.email})</span>)
                                                                    } */}

                                                                    <i className="fa fa-times ms-3" onClick={() => handleCancel(item.heading, key)}></i></Button>
                                                            }</>
                                                        })}
                                                </div>
                                            </div>
                                        )}
                                        </>
                                    );
                                })}
                            </div>
                            
                        </div>
                    </> 
                }
                <div className="row">
                    {
                        getAllTestState.inProgress || (!getAllTestState.success && getAllTestState.error === '' ) 
                        ?
                        <>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '150px'}}>
                                <CircularProgress disableShrink={true}/>
                            </Box>
                        </>
                        :
                        allTest.length > 0 ? (
                        <>
                            {
                                <>
                                {
                                        allTest.map((item, index:number) => {
                                        return (
                                            <>
                                                <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-4" key={index}>
                                                    <div className="card borderedCard ">
                                                        <div className="card-body text-center">
                                                            {
                                                                item.IsPaidTest && item.TrainerId == null &&
                                                                <span className="agent-badge bg-white text-uppercase" title={`${formatMessage('is_paid')}`}>
                                                                    <svg width="20" height="20" viewBox="-160.55 -160.55 1556.10 1556.10" xmlns="http://www.w3.org/2000/svg" fill="#ff0000" stroke="#ff0000" stroke-width="0.012350000000000002" transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#ff0000" stroke-width="148.2"><path d="M0 449h1235l-999 726L618 0l382 1175L0 449z" fill="#ff0000"></path></g><g id="SVGRepo_iconCarrier"><path d="M0 449h1235l-999 726L618 0l382 1175L0 449z" fill="#ff0000"></path></g></svg>
                                                                </span>
                                                            }
                                                            {item.TestType === "LIFE" ? (
                                                                <span className="btn btn-circle mt-2 btn-secondary">
                                                                    {item.TestType}
                                                                </span>
                                                            ) : item.TestType === "TRAINING" ? (
                                                                <span className="btn btn-circle mt-2 btn-warning">
                                                                    {item.TestType}
                                                                </span>
                                                            ) : (
                                                                <span className="btn btn-circle mt-2 btn-success">
                                                                    {item.TestType}
                                                                </span>
                                                            )}
                                                            {(item.TrainerId != null) ? <span className='trainers-badge'><FormattedMessage id="Trainers_invitation" /></span> : ''}
                                                            <h4 className="card-title mb-0 card_name">{item.UserEmail}</h4>
                                                            <p className="card-subtitle small text-muted">
                                                                <svg enable-background="new 0 0 64 64" viewBox="0 0 64 64" fill="currentColor"><g id="Captions"><g><path d="m56.562 17.372c-.316-5.255-4.704-9.372-9.989-9.372h-2.573v-2c0-1.104-.896-2-2-2s-2 .896-2 2v2h-16v-2c0-1.104-.896-2-2-2s-2 .896-2 2v2h-2.573c-5.286 0-9.674 4.117-9.989 9.372-.593 9.884-.582 19.91.033 29.799.312 5.022 4.335 9.045 9.357 9.357 5.033.313 10.102.469 15.171.469 5.068 0 10.138-.156 15.171-.469 5.022-.312 9.045-4.335 9.357-9.357.616-9.884.627-19.909.035-29.799zm-4.026 29.551c-.188 3.013-2.601 5.426-5.613 5.613-9.902.615-19.944.615-29.846 0-3.013-.188-5.426-2.601-5.613-5.613-.473-7.603-.57-15.286-.317-22.923h41.707c.252 7.64.155 15.323-.318 22.923zm-30.536-30.923c1.104 0 2-.896 2-2v-2h16v2c0 1.104.896 2 2 2s2-.896 2-2v-2h2.573c3.173 0 5.807 2.465 5.996 5.611.047.794.067 1.593.106 2.389h-41.35c.04-.796.059-1.595.106-2.389.189-3.146 2.822-5.611 5.996-5.611h2.573v2c0 1.104.896 2 2 2z" /><circle cx="22" cy="33" r="3" /><circle cx="32" cy="33" r="3" /><circle cx="22" cy="43" r="3" /><circle cx="42" cy="33" r="3" /><circle cx="42" cy="43" r="3" /><circle cx="32" cy="43" r="3" /></g></g><g id="Icons" /></svg>
                                                                {item.TestDate}
                                                            </p>
                                                            <div className="mt-4 text-center ">
                                                                <Link className="btn btn-outline-secondary btn-sm mx-2"  to={`${RoutesConstants.TestResult}/${item.TestId}`} target="_blank" title={formatMessage('view_result')}>
                                                                    <svg height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Layer_2" data-name="Layer 2"><rect height="6.5" rx=".75" width="5.5" x="2.25" y="14.25" /><rect height="9.5" rx=".75" width="5.5" x="9.25" y="11.25" /><rect height="13.5" rx=".75" width="5.5" x="16.25" y="7.25" /><path d="m22 22.75h-20a.75.75 0 0 1 0-1.5h20a.75.75 0 0 1 0 1.5z" /><path d="m19 5.75a.76.76 0 0 1 -.75-.75v-2.25h-2.25a.75.75 0 0 1 0-1.5h3a.76.76 0 0 1 .75.75v3a.76.76 0 0 1 -.75.75z" /><path d="m5 10.75a.75.75 0 0 1 -.48-1.33l6-5a.76.76 0 0 1 1 0l1.53 1.58 5.47-4.57a.75.75 0 1 1 1 1.16l-6 5a.75.75 0 0 1 -1 0l-1.52-1.59-5.52 4.58a.78.78 0 0 1 -.48.17z" /></g></svg>
                                                                </Link>
                                                                {
                                                                    (selectedTestsForComparison.filter((testId: any) => testId === item.TestId).length == 1) && item.TestId ?
                                                                        <button className='btn btn-primary btn-sm mx-2' onClick={() => handleRemoveFromCompariosn(item.TestId)} title={formatMessage('remove_from_comparison')}>
                                                                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                                                                viewBox="0 0 512 512"><path d="M76.8,212.3c0-63.6,51.6-115.2,115.2-115.2c63.6,0,115.2,51.6,115.2,115.2c0,63.6-51.6,115.2-115.2,115.2
                                                                            C128.4,327.5,76.8,275.9,76.8,212.3z"/>
                                                                                <path d="M67.6,371c31.6-13.7,72.9-17.9,124.4-17.9c51.5,0,92.9,4.2,124.5,17.9c34.4,14.9,55.3,40.4,66.2,76.4
                                                                            c5.1,16.9-7.5,33.7-25,33.7H26.3c-17.5,0-30.1-16.9-25-33.8C12.3,411.4,33.2,385.9,67.6,371L67.6,371z"/>
                                                                                <path d="M384,97.1h-51.2c-14.1,0-25.6,11.5-25.6,25.6s11.5,25.6,25.6,25.6H384h51.2h51.2c14.1,0,25.6-11.5,25.6-25.6
                                                                            s-11.5-25.6-25.6-25.6h-51.2H384z"/>
                                                                                </svg>
                                                                        </button>
                                                                        :
                                                                        <button className='btn btn-outline-primary btn-sm mx-2' onClick={() => handleAddToComparison(item.TestId)} title={formatMessage('add_to_comparison')}>
                                                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                                                            viewBox="0 0 512 512"><path d="M76.8,212.3c0-63.6,51.6-115.2,115.2-115.2c63.6,0,115.2,51.6,115.2,115.2c0,63.6-51.6,115.2-115.2,115.2
                                                                        C128.4,327.5,76.8,275.9,76.8,212.3z"/>
                                                                            <path d="M67.6,371c31.6-13.7,72.9-17.9,124.4-17.9c51.5,0,92.9,4.2,124.5,17.9c34.4,14.9,55.3,40.4,66.2,76.4
                                                                        c5.1,16.9-7.5,33.7-25,33.7H26.3c-17.5,0-30.1-16.9-25-33.8C12.3,411.4,33.2,385.9,67.6,371L67.6,371z"/>
                                                                            <path d="M435.2,45.9c0-14.1-11.5-25.6-25.6-25.6S384,31.7,384,45.9v51.2h-51.2c-14.1,0-25.6,11.5-25.6,25.6s11.5,25.6,25.6,25.6H384
                                                                        v51.2c0,14.1,11.5,25.6,25.6,25.6s25.6-11.5,25.6-25.6v-51.2h51.2c14.1,0,25.6-11.5,25.6-25.6s-11.5-25.6-25.6-25.6h-51.2V45.9z"/>
                                                                            </svg>
                                                                        </button>
                                                                }
                                                                <button className="btn btn-outline-danger btn-sm mx-2" onClick={() => handleDeleteClick(item.TestId, item.UserEmail)} title={formatMessage('delete')}>
                                                                    <svg version="1.1" id="Layer_1" viewBox="0 0 512 512" >
                                                                        <g>
                                                                            <g>
                                                                                <path d="M62.205,150l26.569,320.735C90.678,493.865,110.38,512,133.598,512h244.805c23.218,0,42.92-18.135,44.824-41.265
                                                        L449.795,150H62.205z M180.986,452c-7.852,0-14.458-6.108-14.956-14.063l-15-242c-0.513-8.276,5.771-15.395,14.033-15.908
                                                        c8.569-0.601,15.381,5.757,15.908,14.033l15,242C196.502,444.632,189.721,452,180.986,452z M271,437c0,8.291-6.709,15-15,15
                                                        c-8.291,0-15-6.709-15-15V195c0-8.291,6.709-15,15-15s15,6.709,15,15V437z M360.97,195.938l-15,242
                                                        c-0.493,7.874-7.056,14.436-15.908,14.033c-8.262-0.513-14.546-7.632-14.033-15.908l15-242
                                                        c0.513-8.276,7.764-14.297,15.908-14.033C355.199,180.543,361.483,187.662,360.97,195.938z"/>
                                                                            </g>
                                                                        </g>
                                                                        <g>
                                                                            <g>
                                                                                <path d="M451,60h-90V45c0-24.814-20.186-45-45-45H196c-24.814,0-45,20.186-45,45v15H61c-16.569,0-30,13.431-30,30
                                                        c0,16.567,13.431,30,30,30c137.966,0,252.039,0,390,0c16.569,0,30-13.433,30-30C481,73.431,467.569,60,451,60z M331,60H181V45
                                                        c0-8.276,6.724-15,15-15h120c8.276,0,15,6.724,15,15V60z"/>
                                                                            </g>
                                                                        </g>
                                                                    </svg>

                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        );
                                    })}
                                </>
                            }
                        </>
                    ) : (
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <svg clip-rule="evenodd" fill-rule="evenodd" height="120" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 64 64" width="120" xmlns="http://www.w3.org/2000/svg"><g id="Exp-2.-F"><path d="m14.387 32.075v-23.365c0-.266.106-.52.293-.707.188-.188.442-.293.707-.293h22.554l11.446 12.692v15.953s.004 1.215-.097 3.083l-5.631-2.043c-.673-.244-1.426-.11-1.973.353-.87.735-2.187 1.849-3.032 2.563-.51.431-1.2.579-1.841.396-1.944-.556-5.974-1.707-5.974-1.707s3.761 2.686 5.769 4.121c.728.52 1.713.493 2.412-.066.898-.719 2.115-1.692 2.931-2.345.551-.44 1.292-.558 1.952-.311l5.176 1.941c-.397 4.314-1.309 9.971-3.398 13.483-.183.289-.501.464-.843.464-3.827.003-26.548.003-32.899.003-.351 0-.676-.184-.857-.485-.18-.301-.19-.675-.025-.984 3.103-6.738 3.33-18.466 3.33-18.466v-1.311l4.388-1.645c.66-.247 1.401-.129 1.951.311.817.653 2.034 1.626 2.932 2.345.699.559 1.684.586 2.412.066 2.008-1.435 5.769-4.121 5.769-4.121s-4.03 1.151-5.974 1.707c-.641.183-1.332.035-1.841-.396-.845-.714-2.162-1.828-3.032-2.563-.547-.463-1.3-.597-1.973-.353z" fill="#cadcf0" /><path d="m48.579 42.153.501.2c-.397 4.314-1.309 9.976-3.399 13.49-.183.289-.501.464-.843.464-3.827.003-26.548.003-32.899.003-.351 0-.676-.185-.857-.486-.18-.3-.19-.674-.025-.984l.039-.086c12.314.579 30.196-1.578 32.551-2.5 1.75-.685 3.818-5.465 4.932-10.101z" fill="#a4bbdb" /><g fill="#347bfa"><path d="m49.387 20.402c-3.035-1.199-6.25-1.233-9.549-.723-.306.048-.617-.049-.842-.263-.224-.214-.337-.52-.304-.828.362-3.694-.003-7.308-.751-10.878 4.838 3.591 8.659 7.819 11.446 12.692z" /><path d="m6.078 23.778 5 5.87c.358.421.989.471 1.409.113s.471-.989.113-1.409l-5-5.87c-.358-.421-.989-.471-1.41-.113-.42.358-.47.989-.112 1.409z" /><path d="m6.132 32.504 3.549.951c.533.143 1.082-.174 1.225-.707s-.174-1.082-.707-1.225l-3.549-.951c-.534-.143-1.082.174-1.225.707s.174 1.082.707 1.225z" /><path d="m5.661 40.729 6.678-3.856c.478-.276.642-.888.366-1.366s-.888-.642-1.366-.366l-6.678 3.856c-.478.276-.642.888-.366 1.366s.888.642 1.366.366z" /><path d="m57.922 51.214-5-5.87c-.358-.42-.989-.47-1.409-.113-.42.358-.471.99-.113 1.41l5 5.87c.358.42.989.471 1.41.113.42-.358.47-.99.112-1.41z" /><path d="m57.868 42.489-3.549-.951c-.533-.143-1.082.174-1.225.707s.174 1.082.707 1.225l3.549.951c.534.142 1.082-.174 1.225-.708.143-.533-.174-1.081-.707-1.224z" /><path d="m58.339 34.264-6.678 3.855c-.478.276-.642.888-.366 1.366s.888.642 1.366.366l6.678-3.855c.478-.276.642-.888.366-1.366s-.888-.642-1.366-.366z" /><path d="m19.864 16.9 3.536 3.536c.39.39 1.024.39 1.414 0 .39-.391.39-1.024 0-1.415l-3.536-3.535c-.39-.39-1.024-.39-1.414 0s-.39 1.024 0 1.414z" /><path d="m23.4 15.486-3.536 3.535c-.39.391-.39 1.024 0 1.415.39.39 1.024.39 1.414 0l3.536-3.536c.39-.39.39-1.024 0-1.414s-1.024-.39-1.414 0z" /><path d="m30.864 16.9 3.536 3.536c.39.39 1.024.39 1.414 0 .39-.391.39-1.024 0-1.415l-3.536-3.535c-.39-.39-1.024-.39-1.414 0s-.39 1.024 0 1.414z" /><path d="m34.4 15.486-3.536 3.535c-.39.391-.39 1.024 0 1.415.39.39 1.024.39 1.414 0l3.536-3.536c.39-.39.39-1.024 0-1.414s-1.024-.39-1.414 0z" /><path d="m22.438 26.409 1.403-1.051s1.397 1.05 1.397 1.05c.356.267.845.267 1.201 0l1.4-1.05s1.4 1.05 1.4 1.05c.355.267.844.267 1.2 0l1.4-1.05s1.4 1.05 1.4 1.05c.441.331 1.069.242 1.4-.2.331-.441.241-1.068-.2-1.4l-1.999-1.5c-.356-.266-.845-.266-1.2 0l-1.401 1.05s-1.4-1.05-1.4-1.05c-.355-.266-.844-.266-1.2 0l-1.4 1.05s-1.396-1.049-1.396-1.049c-.355-.267-.844-.268-1.2-.001l-2.003 1.5c-.442.331-.532.958-.202 1.4.331.441.958.532 1.4.201z" /></g></g></svg>
                            <p className="noData text-muted text-center h4 mb-0"><FormattedMessage id="no_data" /></p>
                        </div>
                    )}

                </div>

                { 
                <CustomPagination
                    onPageLimitChanged={onPageLimitChanged}
                    onPageChanged={onPageChanged}
                    pageSize={testPaginationState.PagingDetails.PageSize}
                    totalPages={testPaginationState.PagingDetails.TotalPages}
                    isRefreshPage={testPaginationState.PagingDetails.isRefreshPage}
                    disablePagination={ allTest.length > 0 ? disablePagination : true }
                />
                }
            </div>

            <TestCompare selectedTestsForComparison={selectedTestsForComparison} removeAll={handleRemoveAllTests} />
           
        </>
    )
}

export default DeletePopupHOC(CreateFilterHOC(injectIntl(observer(Test))));;